import { SvgProps } from "./Form";

export const QuillIcon = ({
  disabled,
  ...props
}: SvgProps & { disabled?: boolean }) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      {!disabled && (
        <linearGradient
          id="quill-icon-gradient"
          x1="2.00098"
          y1="10.0007"
          x2="18.0555"
          y2="10.0007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
      )}
      <clipPath id="rocket-clip">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
    <g clipPath="url(#rocket-clip)">
      <path
        d="M17.1762 2.00268C15.8435 1.99001 13.2302 2.19601 10.9989 3.78068C9.47953 4.85935 6.96953 7.61068 6.6942 11.3333H5.33353V12.8653L3.2582 13.6153C2.3342 13.9847 1.81887 14.9913 2.0602 15.9573L2.57153 17.9993H12.0962L12.6082 15.9567C12.8489 14.9913 12.3335 13.9847 11.3889 13.6067L9.3342 12.8647V11.3327H8.03287C8.07487 10.8433 8.1582 10.3727 8.27953 9.92468C9.13487 9.88468 11.6162 9.61735 14.3075 7.90401C15.9582 6.85335 17.1362 5.15468 17.8089 2.85601L18.0555 2.01268L17.1769 2.00201L17.1762 2.00268ZM10.9142 14.8527C11.2222 14.976 11.3942 15.312 11.3142 15.6333L11.0555 16.666H3.61153L3.35353 15.634C3.27287 15.312 3.44487 14.976 3.73153 14.8607L6.6662 13.8007V12.666H7.99953V13.8007L10.9135 14.8527H10.9142ZM13.5909 6.77935C12.3335 7.57935 11.1242 8.02535 10.1515 8.27601C11.0529 7.41801 12.3742 6.17468 13.3335 5.33268C11.7729 5.82535 10.4062 6.66401 9.42887 7.38401C10.1835 6.21801 11.0909 5.35001 11.7709 4.86735C13.2689 3.80401 14.9829 3.45935 16.2289 3.36601C15.6329 4.89735 14.7482 6.04268 13.5909 6.77935Z"
        fill={disabled ? "#A09CAD" : "url(#quill-icon-gradient)"}
      />
    </g>
  </svg>
);
